import { BpArticle } from '../../../../shared/components/cards/article/BpArticle'
import React from 'react'

interface AdCellProps {
  title: string
  text: string
  finish_domain: string
  shopping_ad_preview_url?: string | null
}

export const AdCell = ({ title, text, finish_domain, shopping_ad_preview_url }: AdCellProps) => {
  return (
    <BpArticle
      link={finish_domain}
      shoppingAdPreviewUrl={shopping_ad_preview_url ?? undefined}
      text={text}
      title={title}
    />
  )
}
